import React from 'react';
import styled from '@emotion/styled';
import { MoreVertical } from '../../../../../../components/Icons/MoreVertical';

const headerTitles = ['Facility UID', 'File Name', 'Date', 'Action'];

const data = [
  {
    facilityId: 'RXD237609IU -765',
    file: 'CAC DOCUMENT',
    date: '14 - 23- 2023',
    action: <MoreVertical />,
  },
  {
    facilityId: 'RXD237609IU -765',
    file: 'OPERATING LICENCE FMOH',
    date: '14 - 23- 2023',
    action: <MoreVertical />,
  },
];

const Documents = () => {
  return (
    <Container>
      <Header className="row">
        {headerTitles.map((data: string, index) => (
          <div key={index}>{data}</div>
        ))}
      </Header>
      <DocBreakdown>
        {data.map((item, index) => (
          <div key={index} className="row">
            <div>{item.facilityId}</div>
            <div className="file">{item.file}</div>
            <div>{item.date}</div>
            <div className="action">{item.action}</div>
          </div>
        ))}
      </DocBreakdown>
    </Container>
  );
};

export default Documents;

const Container = styled.div`
  display: grid;
  border-top: 1px solid ${({ theme }) => theme.palette.greyGrey3};
  font-weight: 400;
  font-size: 18px;
  line-height: 26px;

  @media (max-width: 480px) {
    font-size: 12px;
    line-height: 22px;
  }
`;

const Header = styled.div`
  color: ${({ theme }) => theme.palette.greyGrey1};

  &.row {
    display: grid;
    grid-template-columns: 1.2fr 2fr 1fr 0.5fr;
    // text-align: center;
    height: 52px;
    align-items: center;
  }
`;

const DocBreakdown = styled.div`
  background-color: ${({ theme }) => theme.palette.greyGrey4};
  margin-top: 10px;

  & > div:nth-of-type(even) {
    background-color: white;
  }

  & > .row {
    display: grid;
    grid-template-columns: 1.2fr 2fr 1fr 0.5fr;
    height: 52px;
    align-items: center;

    &:hover {
      background-color: ${({ theme }) => theme.palette.stateColorGreenLight};
    }

    & > .file {
      color: ${({ theme }) => theme.palette.mainBlue};
      white-space: nowrap;
    }

    & > .action {
      cursor: pointer;
    }
  }
`;
